import { render, staticRenderFns } from "./SystemDialogModal.vue?vue&type=template&id=87d77d56&scoped=true&"
import script from "./SystemDialogModal.vue?vue&type=script&lang=js&"
export * from "./SystemDialogModal.vue?vue&type=script&lang=js&"
import style0 from "./SystemDialogModal.vue?vue&type=style&index=0&id=87d77d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d77d56",
  null
  
)

export default component.exports